import React, { useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import { connect } from "react-redux";
import {
  HiOutlineChevronDown,
  HiOutlineKey,
  HiOutlineCash,
  HiOutlineOfficeBuilding,
  HiOutlineUserGroup,
  HiOutlineClipboardList,
} from "react-icons/hi";
import { scrollTop } from "../../utils/window";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";

const publicUrl = process.env.PUBLIC_URL || "";

function RequiredDocuments() {
  const { feedback } = useContext(FeedbackContext);
  const requiredDocuments = feedback.requridocuments_page;

  const [expandedOwn, setExpandedOwn] = useState(false);
  const [expandedFinance, setExpandedFinance] = useState(false);
  const [expandedCompany, setExpandedCompany] = useState(false);
  const [expandedFriend, setExpandedFriend] = useState(false);

  useEffect(() => {
    scrollTop();
  }, []);

  const documentGroups = [
    {
      id: "own",
      icon: HiOutlineKey,
      title: requiredDocuments.I_own_my_vehicle_heading,
      isOpen: expandedOwn,
      onToggle: () => setExpandedOwn(!expandedOwn),
      docs: [
        requiredDocuments.I_own_my_vehicle_doc_1,
        requiredDocuments.I_own_my_vehicle_doc_2,
        requiredDocuments.I_own_my_vehicle_doc_3,
        requiredDocuments.I_own_my_vehicle_doc_4,
      ],
    },
    {
      id: "finance",
      icon: HiOutlineCash,
      title: requiredDocuments.some_money_on_my_vehicle_heading,
      isOpen: expandedFinance,
      onToggle: () => setExpandedFinance(!expandedFinance),
      docs: [
        requiredDocuments.I_own_my_vehicle_doc_1,
        requiredDocuments.I_own_my_vehicle_doc_2,
        requiredDocuments.I_own_my_vehicle_doc_3,
        requiredDocuments.I_own_my_vehicle_doc_4,
      ],
    },
    {
      id: "company",
      icon: HiOutlineOfficeBuilding,
      title: requiredDocuments.vehicle_belonging_to_company_heading,
      isOpen: expandedCompany,
      onToggle: () => setExpandedCompany(!expandedCompany),
      docs: [
        requiredDocuments.vehicle_belonging_to_company_doc_1,
        requiredDocuments.vehicle_belonging_to_company_doc_2,
        requiredDocuments.vehicle_belonging_to_company_doc_3,
        requiredDocuments.vehicle_belonging_to_company_doc_4,
      ],
    },
    {
      id: "friend",
      icon: HiOutlineUserGroup,
      title: requiredDocuments.behalf_of_friend_heading,
      isOpen: expandedFriend,
      onToggle: () => setExpandedFriend(!expandedFriend),
      docs: [
        requiredDocuments.behalf_of_friend_doc_1,
        requiredDocuments.behalf_of_friend_doc_2,
        requiredDocuments.behalf_of_friend_doc_3,
        requiredDocuments.behalf_of_friend_doc_4,
      ],
    },
  ];

  return (
    <div className="pi-info pi-docs">
      <header className="pi-inner-hero pi-info__hero">
        <div className="pi-inner-hero__media" aria-hidden="true">
          <img
            className="pi-inner-hero__media-img pi-info__hero-img"
            src={`${publicUrl}/images/info-documents-hero.jpg`}
            alt=""
          />
          <span className="pi-inner-hero__media-shade" />
        </div>
        <div className="pi-inner-hero__fx" aria-hidden="true">
          <span className="pi-inner-hero__glow pi-inner-hero__glow--a" />
          <span className="pi-inner-hero__glow pi-inner-hero__glow--b" />
          <span className="pi-inner-hero__grid" />
        </div>
        <div className="pi-inner-hero__content">
          <div className="pi-inner-hero__copy pi-info__reveal pi-info__reveal--1">
            <p className="pi-label pi-inner-hero__label">Checklist</p>
            <h1 className="pi-inner-hero__title">{requiredDocuments.Bringing_Documents_heading}</h1>
          </div>
        </div>
        <span className="pi-inner-hero__fade" aria-hidden />
      </header>

      <div className="pi-info__body">
        <div className="pi-info__body-fx" aria-hidden="true">
          <span className="pi-info__body-glow pi-info__body-glow--a" />
          <span className="pi-info__body-glow pi-info__body-glow--b" />
        </div>
        <div className="pi-info__inner">
          <div className="pi-info__layout">
            <main className="pi-info__main pi-info__reveal pi-info__reveal--2">
              <div className="pi-docs__list">
                {documentGroups.map((group) => {
                  const Icon = group.icon;
                  return (
                    <article
                      key={group.id}
                      className={`pi-docs__item ${group.isOpen ? "is-open" : ""}`}
                    >
                      <button
                        type="button"
                        className="pi-docs__trigger"
                        onClick={group.onToggle}
                        aria-expanded={group.isOpen}
                      >
                        <span className="pi-docs__icon" aria-hidden>
                          <Icon size={20} />
                        </span>
                        <h3>{group.title}</h3>
                        <HiOutlineChevronDown className="pi-docs__chevron" aria-hidden />
                      </button>
                      <Collapse in={group.isOpen}>
                        <div className="pi-docs__panel">
                          <ul>
                            {group.docs.map((doc) => (
                              <li key={doc}>{doc}</li>
                            ))}
                          </ul>
                        </div>
                      </Collapse>
                    </article>
                  );
                })}
              </div>
            </main>

            <aside className="pi-info__aside pi-info__reveal pi-info__reveal--3">
              <div className="pi-info__art">
                <span className="pi-info__art-grid" aria-hidden />
                <span className="pi-info__art-icon" aria-hidden>
                  <HiOutlineClipboardList size={24} />
                </span>
                <h3>Bring the right papers</h3>
                <p>Select your situation below to see exactly which documents you need on appointment day.</p>
                <div className="pi-info__art-chips">
                  <span className="pi-info__art-chip">4 scenarios</span>
                  <span className="pi-info__art-chip">Fast check-in</span>
                </div>
              </div>

              <div className="pi-info__card" style={{ marginTop: "1rem" }}>
                <p className="pi-label" style={{ marginBottom: "0.5rem" }}>Tip</p>
                <p className="pi-info__prose" style={{ margin: 0, fontSize: "0.875rem" }}>
                  Have originals and copies ready. Missing documents may delay your appointment.
                </p>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  mycardata: state.myAppointment.data,
  appointment_update: state.sellMyCar,
});

export default connect(mapStateToProps)(RequiredDocuments);
